// extracted by mini-css-extract-plugin
export var backdropBlur = "_l9-0";
export var contentCard = "_l9-5";
export var frame = "_l9-2";
export var image = "_l9-4";
export var imagePane = "_l9-3";
export var modal = "_l9-1";